import { useContext, useState, Fragment, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { otpResultado, trackEvent } from "../../services/analytics/track";

import { Forms } from "../../components/backgrounds/Forms";
import { Primary } from "../../components/buttons/Primary";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { Steps, titles } from "../../components/buttons/Steps";
import { ProgressLinear } from "../../components/progress/progressLinear";
import { Otp, digitosFirma } from "../../components/legal/Otp";
import { AuthContext } from "../../context/Auth/AuthContext";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { HttpRequest } from "../../services/httpRequest";
import { validateSessionAndJwtToken } from "../../utils/validateTokenSession";
// import TagManager from "../../components/googleTag/TagManager";
import { returnToSignin } from "../../utils/returnToSign";
import { FloatFooter } from "../../components/navigation/FloatFooter";
import ViewTimer from "../../components/timers/viewTimer";
import { handleAddTimeline } from "./helpers/helper";
import {
  getPostbackContext,
  storeUtmSettlement,
} from "../../services/utmleads/utmReferral";

export function FirmaPage() {
  const { phone, token } = useContext(AuthContext);
  const { creditUser } = useContext(CreditUserContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [viewProgress, setViewProgress] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [celularProtect, setCelularProtect] = useState("");
  const [successSignature, setSuccessSignature] = useState(false);

  const handleProgress = (isView) => {
    setViewProgress(isView);
  };

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenSuccess(false);
        setViewalert(false);
      }, 20000);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenError(false);
        setViewalert(false);
      }, 20000);
    }
  };

  //Se consulta en la base de datos si el usuario tiene un credito vigente
  const hasActiveCredit = async () => {
    try {
      let response = await HttpRequest.hasActiveCredit(
        localStorage.getItem("doc"),
      );
      return response.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleProgress(true);
    let doc;
    if (creditUser.documento) {
      doc = creditUser?.documento || localStorage.getItem("doc");
    } else if (state) {
      if (state.isRenovateCredit === true) {
        doc = state?.doc || localStorage.getItem("doc");
      }
    }
    let data = {
      doc: doc,
      idCredit: localStorage.getItem("credit_id"),
      token: token,
      postbackContext: getPostbackContext(),
    };
    try {
      let hasActive = await hasActiveCredit();
      if (hasActive) {
        handleOpenAlert(
          "error",
          "No es posible llevar a cabo la firma, ya usted posee un crédito en estado Vigente.",
          true,
        );
        setTimeout(() => {
          navigate("/micredito", { replace: true });
        }, 7000);
        return;
      }
      const responseService = await HttpRequest.validateOtpSignature(data);
      trackEvent("otp_verificado", { contexto: "firma", resultado: otpResultado(responseService) });
      if (responseService.error) {
        setSuccessSignature(false);
        handleProgress(false);
        if (responseService.message.code === "INVALIDTOKEN") {
          handleOpenAlert("error", "Token inválido", true);
        } else if (responseService.message.code === "INVALIDQUOTA") {
          handleOpenAlert("error", responseService?.message?.message, true);
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          handleOpenAlert("error", responseService?.message?.message, true);
        }
      } else {
        storeUtmSettlement(responseService.message);
        trackEvent("credito_firmado", {
          revenue: creditUser?.approvedQuota,
          currency: "COP",
          plazo_dias: creditUser?.termInDays,
          tipo_cliente: state?.isRenovateCredit === true ? "renovacion" : "nuevo",
        });
        handleProgress(false);
        localStorage.setItem("doc", creditUser?.documento);
        localStorage.setItem("is_signin", true);
        return navigate("/confirmado", {
          replace: true,
          state: {
            provieneFirma: true,
            doc: creditUser?.documento,
            creditId: creditUser?.credit_id,
          },
        });
      }
    } catch (error) {
      handleProgress(false);
      handleOpenAlert(
        "error",
        "Ups!, no pudimos validar tu código, intenta nuevamente!",
        true,
      );
    }
  };

  const resendCodeSignature = async (e) => {
    e.preventDefault();
    trackEvent("otp_reenviado", { contexto: "firma" });
    let data = {
      doc: creditUser.documento || "",
      phone: phone,
      credit_id: creditUser.credit_id || "",
    };
    try {
      const responseService = await HttpRequest.requestSignature(data);
      if (responseService.error) {
        handleProgress(false);
        return handleOpenAlert(
          "error",
          "Ups!, no pudimos reenviar el código, intenta nuevamente!",
          true,
        );
      }
      handleOpenAlert("success", "Código reenviado exitosamente!!", true);
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          let phone = localStorage.getItem("phone");
          if (phone && typeof phone === "string") {
            let celularProtect = "********" + phone.substring(8);
            setCelularProtect(celularProtect);
          }
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [navigate]);

  if (isLoading) {
    return (
      <Fragment>
        <ViewTimer
          creditId={localStorage.getItem("credit_id")}
          viewName="Firma"
          description="Firma electrónica de crédito"
          pathView="/firma"
          hasSuccess={successSignature}
          onSaveTimeline={handleAddTimeline}
          idOperation={localStorage.getItem("idOperation")}
        />
        <div className="bg-purpleLight h-screen">
          <Steps
            estado1="complete"
            estado2="complete"
            estado3="complete"
            estado4="current"
          />
          <Forms
            title={titles[3].name}
            description={"Cargando la información."}
            form={
              <form action="#" method="POST" onSubmit={handleSubmit}>
                <div className="shadow-lg overflow-hidden rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="my-8"></div>
                  </div>
                </div>
              </form>
            }
          />
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {/* <TagManager /> */}
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}
      <div className="bg-purpleLight h-screen">
        <Steps
          estado1="complete"
          estado2="complete"
          estado3="complete"
          estado4="current"
        />
        <Forms
          title={titles[3].name}
          description={
            "Digita el código que hemos enviado a tu número de celular para firmar los documentos."
          }
          form={
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="shadow-lg overflow-hidden rounded-md">
                <div className="px-4 py-5 bg-white sm:p-6">
                  <div className="my-8">
                    <div className="text-center">
                      <div className="mb-4">
                        <h2 className="uppercase font-bold">
                          Vía SMS y WhatsApp
                        </h2>
                        <p className="">
                          Escribe el código de{" "}
                          <span className="font-bold">
                            {digitosFirma} dígitos
                          </span>{" "}
                          que te envíamos a tu celular registrado +57{" "}
                          {celularProtect}{" "}
                        </p>
                      </div>
                      <div className="block">
                        <Otp name="tokensms" id="tokensms" />
                      </div>
                    </div>
                  </div>

                  <div className="mx-auto text-center px-4 py-6 md:flex md:justify-end bg-white md:text-right sm:px-6">
                    <div className="mx-auto w-56">
                      {viewProgress ? (
                        <Fragment>
                          <ProgressLinear></ProgressLinear>
                          <p style={{ fontSize: 13 }}>
                            Estamos validando tu código, por favor espera...
                          </p>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Primary text="Firmar documentos" />
                          <button
                            onClick={resendCodeSignature}
                            className="mt-4 px-5 text-center"
                          >
                            Reenviar código
                          </button>
                        </Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          }
        />
      </div>
      <FloatFooter />
    </Fragment>
  );
}
